import {
  FlexGrid,
  FlexGridItem,
  HeadingLarge,
  LabelSmall,
  ParagraphMedium,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { selectWalletBalances, useDappSelector } from "#/redux-state"
import {
  bigIntToHumanReadableFormat,
  separateThousandsWithComaRegExp,
} from "#/shared/utils"

import { TokenIcon } from "../Token"

export default function MarketHeader() {
  const { MUSD } = useDappSelector(selectWalletBalances)

  const [css, theme] = useStyletron()

  return (
    <FlexGrid
      flexGridColumnCount={2}
      flexGridColumnGap="scale900"
      alignItems="flex-end"
      marginBottom={theme.sizing.scale1000}
    >
      <FlexGridItem>
        <HeadingLarge>
          Be an early collector and grab exclusive <br />
          Mezo swag with MUSD!
        </HeadingLarge>
        <ParagraphMedium color="contentSecondary">
          Limited drops, exclusive perks—secure yours with MUSD!
        </ParagraphMedium>
      </FlexGridItem>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({
              flexGrow: 0,
              width: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }),
          },
        }}
      >
        <ParagraphSmall
          color={theme.colors.contentTertiary}
          marginBottom={theme.sizing.scale100}
        >
          Available balance
        </ParagraphSmall>
        <LabelSmall
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale100,
          })}
        >
          <TokenIcon token="MUSD" />
          {separateThousandsWithComaRegExp(
            bigIntToHumanReadableFormat(
              MUSD.balance,
              Number(MUSD.decimals),
              Number(MUSD.decimals),
            ),
          )}{" "}
          MUSD
        </LabelSmall>
      </FlexGridItem>
    </FlexGrid>
  )
}
